module.exports = __webpack_public_path__ + "img/hotpro_hot.725987c.webp";